import { APPEND_PERMISSIONS } from '../actionsList';



const initialInfo = {
    permissions: {}
};
const permissionsReducer = (state = initialInfo, action) => {

    switch (action.type) {

        case APPEND_PERMISSIONS: {
            let permissions = state.permissions

            if (!permissions) {
                permissions = {}
            }
            if (!permissions[action.applet]) {
                permissions[action.applet] = []
            }

            action.permissions.map((permission) => {
                let found = false
                permissions[action.applet].map((onePermission) => {
                    if (permission._id == onePermission._id) {
                        found = true
                    }
                })
                if (!found) {
                    permissions[action.applet].push(permission)
                }
            })

            // console.log(key)
            // console.log(list)

            return {
                ...state,
                permissions: permissions,
            }

        }
        default:
            return state;
    }
}
export default permissionsReducer;